import { GlobalToken } from 'antd';
import styled from 'styled-components';

export const HomeContentContainer = styled.div<{ theme: { token: GlobalToken } }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${({ theme: { token } }) => token.marginLG}px;
  margin: 0 auto;
  padding: ${({ theme: { token } }) => `${token.paddingXL}px 0`};
  max-width: 28.8125rem;

  .welcome-header {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .welcome-title {
    width: 100%;
    color: ${({ theme: { token } }) => token.colorText};
    font-size: ${({ theme: { token } }) => token.fontSizeHeading1}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    word-wrap: break-word;
    margin: 0;
    text-align: center;
  }

  .welcome-description {
    align-self: stretch;
    color: ${({ theme: { token } }) => token.colorText};
    font-size: ${({ theme: { token } }) => token.fontSize}px;
    word-wrap: break-word;
    margin: 0 auto;
    max-width: 28.8125rem;
    text-align: center;
  }

  .welcome-form-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    max-width: 17.5rem;
  }

  .account-id-item {
    margin-bottom: ${({ theme: { token } }) => token.margin}px;
    width: 100%;
  }

  .region-item {
    margin-bottom: ${({ theme: { token } }) => token.margin}px;
    width: 100%;
  }

  .button-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
  }
`;
